export interface AreaGroup {
  group: string;
  areas: string[];
}

export const AREA_OPTIONS: AreaGroup[] = [
  { group: '北海道', areas: ['道央', '道南', '道北', '道東'] },
  { group: '東北', areas: ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'] },
  { group: '北関東', areas: ['茨城県', '栃木県', '群馬県'] },
  { group: '埼玉県', areas: ['埼玉県'] },
  { group: '千葉県', areas: ['千葉県'] },
  { group: '東京都', areas: ['東京23区', '多摩地区'] },
  { group: '神奈川県', areas: ['横浜・川崎', '湘南', '相模原', '西湘'] },
  { group: '甲信越・北陸', areas: ['新潟県', '富山県', '石川県', '福井県', '山梨県'] },
  { group: '長野県', areas: ['北信', '東信', '中信', '南信'] },
  { group: '東海', areas: ['岐阜県', '三重県'] },
  { group: '愛知県', areas: ['名古屋・尾張', '三河'] },
  { group: '静岡県', areas: ['伊豆', '静岡東部', '静岡中部', '静岡西部'] },
  { group: '近畿', areas: ['滋賀県', '京都府', '奈良県', '和歌山県'] },
  { group: '大阪府', areas: ['大阪市内', '北摂', '河内・泉州'] },
  { group: '兵庫県', areas: ['神戸・阪神', '播磨', '但馬・丹波', '淡路島'] },
  { group: '中国', areas: ['鳥取県', '島根県', '岡山県', '広島県', '山口県'] },
  { group: '四国', areas: ['徳島県', '香川県', '愛媛県', '高知県'] },
  {
    group: '九州',
    areas: ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県'],
  },
  { group: '沖縄県', areas: ['沖縄県'] },
];
